import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyFieldProps } from "@ngx-formly/core";
import { ButtonModule } from "primeng/button";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import {
  TransactionAttachmentFileInfo,
  TransactionEntryAttachment,
  TransactionFileUploadState,
} from "../../../../../domain/transaction-entry";
import { FormlyFieldPropsTranslatable } from "../../../../types/form";
import { TransactionAttachmentComponent } from "../../transaction-attachment/transaction-attachment.component";

export function isFileDownloadDisplayField(field: FormlyFieldConfig): field is FormlyFieldConfig & {
  type: "fileDownloadDisplay";
  props: FormlyFieldPropsTranslatable & FileDownloadDisplayProps;
} {
  return field.type === "fileDownloadDisplay";
}

interface FileDownloadDisplayProps extends FormlyFieldProps {
  transactionId: number;
  onAttachmentDeleted?: (parentEntry: TransactionEntryAttachment) => void;
}

@Component({
  selector: "app-formly-file-download-display",
  templateUrl: "./file-download-display.type.html",
  standalone: true,
  imports: [CommonModule, TranslocoDirective, ButtonModule, ProgressSpinnerModule, TransactionAttachmentComponent],
})
export class FileDownloadDisplayComponent extends FieldType<FieldTypeConfig<FileDownloadDisplayProps>> {
  public FileUploadStateEnum = TransactionFileUploadState;

  constructor() {
    super();
  }

  get attachmentEntries(): TransactionEntryAttachment[] {
    const fieldValue = this.formControl.value;
    if (fieldValue && fieldValue._isFileDownloadData) {
      return fieldValue.attachmentEntries || [];
    }
    return [];
  }

  get hasFiles(): boolean {
    return this.allFiles.length > 0;
  }

  get allFiles(): { file: TransactionAttachmentFileInfo; parentEntry: TransactionEntryAttachment }[] {
    const items = this.attachmentEntries.flatMap((entry) =>
      (entry.attachedFiles ?? []).map((file) => ({ file, parentEntry: entry })),
    );
    // Active files first, deleted ones at the bottom
    return items.sort((a, b) => {
      const aDeleted = a.file.deletedAt ? 1 : 0;
      const bDeleted = b.file.deletedAt ? 1 : 0;
      if (aDeleted !== bDeleted) {
        return aDeleted - bDeleted;
      }
      return a.file.id - b.file.id;
    });
  }
}
